"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const CustomerSupportIcon = createSVGIcon(
  <>
    <path
      d="M5.897 13.715v-2.846A9.92 9.92 0 0 1 16 1.143a9.92 9.92 0 0 1 10.103 9.726v2.845"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.428 13.714h3.429A1.143 1.143 0 0 1 8 14.857v6.286a1.143 1.143 0 0 1-1.143 1.142H3.428A2.286 2.286 0 0 1 1.143 20v-4a2.286 2.286 0 0 1 2.285-2.286ZM28.572 22.286h-3.429A1.143 1.143 0 0 1 24 21.143v-6.286a1.143 1.143 0 0 1 1.143-1.142h3.429A2.286 2.286 0 0 1 30.857 16v4a2.286 2.286 0 0 1-2.285 2.286ZM21.348 28.572A4.665 4.665 0 0 0 26.103 24v-1.714"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.217 26.286h7.132v4.571h-7.132z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CustomerSupportIcon",
  {
    viewBox: "0 0 32 32",
    fill: "none",
    color: "#888888",
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
